import { formatKey } from "../_helper";
import { Link } from "react-router-dom";

const ProfileSectionWithHistoryButton = ({ title, data, link }) => {
  return (
    <section className="tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative">
      <div className="tw-pb-2 tw-flex max-md:tw-flex-col max-md:tw-gap-4 justify-content-between tw-items-center tw-mb-4 tw-border-b">
        <h3 className="tw-text-xl tw-font-semibold tw-text-primary tw-p-0 !tw-m-0">
          {title}
        </h3>

        <Link
          to={link}
          className="!tw-no-underline btn-primary tw-flex tw-items-center max-md:tw-text-[13px] tw-max-h-10 tw-text-[14px] tw-px-2 tw-py-2 !tw-m-0 !tw-pe-4  tw-font-semibold !tw-rounded-lg tw-border tw-border-[#837D7D]/50 tw-shadow-[0px_1px_4px_0px_#00000040]"
        >
          <span className="material-icons tw-me-1">history</span>
          <span>View History </span>
        </Link>
      </div>

      <div
        className={`tw-grid lg:tw-grid-cols-2 tw-gap-2 tw-text-black tw-font-medium`}
      >
        {Object.entries(data).map(([key, value]) => (
          <div key={key}>
            <p>
              <strong className="tw-text-secondary">{formatKey(key)}:</strong>{" "}
              {value}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProfileSectionWithHistoryButton;
